import React from 'react';
import { Receipt, Camera, FolderX } from 'lucide-react';

const CARDS = [
  {
    icon: Receipt,
    title: '27 years of unfiled tax docs',
    body:
      "Receipts from 1997. W-2s scanned in 2009. A folder called \"2023 taxes FINAL\" right next to \"2023 taxes FINAL v2\". You know it's all important. You just have no idea where any specific document lives, and accountant season is one week away.",
  },
  {
    icon: Camera,
    title: 'Family photos scattered everywhere',
    body:
      "iCloud Photos, the old iPhoto library, the SD card backup from 2014, a Google Drive folder your spouse made, three USB sticks. Same wedding got dropped by the photographer in four batches: \"All Images (Print)\", \"(Print) 2\", \"(Print) 3\", and \"photos-6_of_10\". You want one folder per year, sorted by date taken.",
  },
  {
    icon: FolderX,
    title: 'Duplicate-folder chaos after a move',
    body:
      "House build documents from three different contractors. Quotes, plans, door specs, window specs, council approvals. Some files are in Downloads, some on the Desktop, some emailed to yourself, some in a folder called \"Mitchell Street House\" that's nested four levels deep. You need one tidy project archive.",
  },
];

const PainPoints = () => {
  return (
    <section id="problem" className="my-20">
      <div className="text-center mb-14">
        <h2 className="text-3xl sm:text-4xl font-semibold mb-4 tracking-tight text-apple-50">
          You already know the problem
        </h2>
        <p className="text-apple-300 text-lg font-light max-w-2xl mx-auto">
          Three scenarios we hear from almost every household.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {CARDS.map((card, i) => {
          const Icon = card.icon;
          return (
            <div
              key={i}
              className="bg-apple-800/40 backdrop-blur-sm rounded-2xl border border-apple-700/50 p-6"
            >
              <div className="w-10 h-10 rounded-full bg-sortio-secondary/15 border border-sortio-secondary/30 flex items-center justify-center mb-4">
                <Icon className="text-sortio-secondary" size={18} />
              </div>
              <h3 className="text-lg font-medium text-apple-50 mb-3">{card.title}</h3>
              <p className="text-sm text-apple-200 leading-relaxed">{card.body}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default PainPoints;
